module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/supplements@3x_ac0a07.png";